import { render } from "./SeoChildProductCell.vue?vue&type=template&id=a8720e60&scoped=true"
import script from "./SeoChildProductCell.vue?vue&type=script&lang=js"
export * from "./SeoChildProductCell.vue?vue&type=script&lang=js"

import "./SeoChildProductCell.vue?vue&type=style&index=0&id=a8720e60&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8720e60"]])

export default __exports__